"use client";

import React from "react";

import { SupText } from "@repo/core-ui";
import UiMessageRestricted from "@/components/Ui/Message/Restricted";
import { twMerge } from "tailwind-merge";

interface GridEmptyStateProps {
  message?: string;
  description?: string;
  isFiltered?: boolean;
  isError?: boolean;
}

export default function GridEmptyState({
  message = "NO RESULTS FOUND",
  isFiltered = false,
  isError = false,
  description = "Superform is having issues. Try again later.",
}: GridEmptyStateProps) {
  const errorDescription = isFiltered ? "Your current applied filters may be filtering out results." : isError ? description : undefined;

  return (
    <UiMessageRestricted description={errorDescription} showConnect={false}>
      <SupText
        variant="button"
        className={twMerge(
          "flex h-12 w-full cursor-default items-center justify-center whitespace-nowrap rounded-b-3xl bg-neutral-600 uppercase text-neutral",
          isError && "bg-error-700"
        )}
      >
        {message}
      </SupText>
    </UiMessageRestricted>
  );
}
